/*
 * @Author: wangshengqiang
 * @Date: 2021-05-18 11:28:39
 * @LastEditTime: 2021-07-02 15:11:04
 * @LastEditors: wangshengqiang
 * @Description: 弹框组件
 */
export { default as text } from './components/text';
export { default as params } from './components/params';
export { default as picture } from './components/picture';
export { default as renderModal } from './RenderModal'; // export * from './Modal.js';

export { default } from './Modal.js';